import { useForm, Controller, type SubmitHandler } from "react-hook-form"
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import EokoCustomersLoader from "@/wrappers/eoko-customers-loader"
import { useCreateByEokoCustomer } from "@/hooks/api/use-collection-company"

const CollectionCompanyForm = ({
    closeCallback,
} : {
    closeCallback?: () => void,
}) => {

    const initialValues = {
        id: '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
        error,
        setError,
    } = useFormStates(() => reset(initialValues))

    const mutation = useCreateByEokoCustomer(
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            }
        }
    )

    const onSubmit: SubmitHandler<{id: string}> = data => {
        setRequestInProgress(true)
        mutation.mutate(data.id)
    }

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={'Nahrát svozovou společnost z EOKA'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            error={error}
            setError={setError}
            buttonText="Uložit"
        >
            <EokoCustomersLoader>
                {eokoCustomers => (
                    <FormControl fullWidth>
                        <InputLabel id="collection-company-select-label">Vyberte z EOKO zákazníků</InputLabel>
                        <Controller
                            name="id"
                            control={control}
                            render={({ field }) => (
                                <Select {...field} label="Vyberte z EOKO zákazníků">
                                    <MenuItem key="none" value="">-</MenuItem>
                                    {eokoCustomers.map(customer => (
                                        <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                )}
            </EokoCustomersLoader>
        </Form>
    )
}

export default CollectionCompanyForm
